import IserbaScorePermis from "./cumulatedScore/iserba/IserbaScorePermis";

const CumulatedScore = ({ quizId, quizResults }) => {
	if (quizId === "d58b69c0-1c30-4473-a1f2-668305ef3f93") {
		return <IserbaScorePermis quizResults={quizResults} />;
	}
	return <div>Score: {quizResults.score}</div>;
};

export default CumulatedScore;
